import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Table,
    TextLink,
    TextInput,
    FilterDropdown,
    SearchButton,
    LightTextButton,
    PageNavigator,
    Loader
} from "components";
import {customersAction, ordersAction} from "redux/actions";
import {useHistory, useLocation} from "react-router-dom";
import {adminToken, getDay, internalSearch} from "helper";
import styles from "./styles.module.scss";
import {Modal} from "@material-ui/core";
import ReportModal from "../../Report/ReportModal";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
import axios from "axios";
import {AWS_URL_UM_INT_8089,AWS_SERVER_APIS} from "../../../configurations";
import OrderModal from "../modals/OrderModal";
import TableOrder from "components/Table/TableOrder";

export default function Orders() {
    const [openModal, setOpenModal] = useState(false)

    const history = useHistory();
    const currentLocation = history.location.pathname;

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openOrderModal, setOpenOrderModal] = useState(false)

    const handleOpenOrderModal = () => {
        setOpenOrderModal(true)
    }

    const handleCloseOrderModal = () => {
        setOpenOrderModal(false)
    }

    const [clickedOrder, setClickedOrder] = useState(null);

    // Routers
    const {
        push,
        location: {pathname}
    } = useHistory();

    const locationSearch = useLocation().search;
    const query = new URLSearchParams(locationSearch);
    const orderID = query.get("orderID");

    const spID = localStorage.getItem("spID")
    const orderIDFromSub = localStorage.getItem("orderID")

    // States
    const [tableRows, setTableRows] = useState();

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setfilterState] = useState({status: "All"});
    const [cPage, setCPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [spLoader, setSpLoader] = useState(false);
    const [orderData, setOrderData] = useState([]);
    const [searchData, setSearchData] = useState('');
    const [topDetails, setTopDetails] = useState('');
    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)
    const [clickedSubscription, setClickedSubscription] = useState(null)
    const [clickedCustomer, setClickedCustomer] = useState(null)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    // Clear Search
    const clearSearch = () => {
        window.location.reload();
    };

    // Redux actions
    const dispatch = useDispatch();
    const {customers, orders, userRole} = useSelector(state => ({
        orders: state.orders,
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Orders")
    }));
    

    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read")) {
            setSpLoader(true);
            adminToken().then(token => axios
                .get(
                    `${AWS_SERVER_APIS}/getorderlist?per_page=10&page=${cPage}&order_id=${(orderIDFromSub)?orderIDFromSub:(filterState.orderID)?filterState.orderID:''}&sub_id=${(filterState.subscriptionID)?filterState.subscriptionID:''}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                .then(res => {
                    setOrderData(res.data);
                    setLastPage(res.data.maxPages);
                    setSpLoader(false);
                })
            )
        }
    }, [searchData,cPage])

    // useEffect(() => {
    //     if (userRole?.find(item => item.privilege === "Read"))
    //         dispatch(ordersAction.get(1,10));
    // }, []);

    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(customersAction.get(1));
        return () => dispatch(customersAction.reset());
    }, []);


    useEffect(() => {
        let filtered = orderData.orders;
        if(filtered){
            var top_details = `
                        <ul style="padding: 10px 0 0; margin:0px; margin-left: -16px;">
                            <li style="display: inline-block; border-right: 1px solid #555; padding: 0px 15px; margin: 3px 0; fontSize: 18px">Order: ${filtered[0]?.cartID}</li>
                            <li style="display: inline-block; border-right: 1px solid #555; padding: 0px 15px; margin: 3px 0; fontSize: 18px">Customer: ${filtered[0]?.cart_data?.user_id}</li>
                            <li style="display: inline-block; border-right: 1px solid #555; padding: 0px 15px; margin: 3px 0; fontSize: 18px">Package: ${filtered[0]?.get_cart_package_details[0]?.package_name}</li>
                            <li style="display: inline-block; border-right: 1px solid #555; padding: 0px 15px; margin: 3px 0; fontSize: 18px">Address: <a href="https://www.google.com/maps/search/?api=1&query=${filtered[0]?.service_address[0]?.latitude},${filtered[0]?.service_address[0]?.longitude}" target="_blank">${filtered[0]?.service_address[0].line2}</a></li>
                            <li style="display: inline-block; border-right: 1px solid #555; padding: 0px 15px; margin: 3px 0; fontSize: 18px">City: ${filtered[0]?.service_address[0]?.city}</li>
                            <li style="display: inline-block; border-right: 1px solid #555; padding: 0px 15px; margin: 3px 0; fontSize: 18px">Start Date: ${filtered[0]?.schedule?.start_date}</li>
                            <li style="display: inline-block; border-right: 1px solid #555; padding: 0px 15px; margin: 3px 0; fontSize: 18px">End Date: ${filtered[0]?.schedule?.end_date}</li>
                            <li style="display: inline-block; padding: 0px 15px; margin: 3px 0; fontSize: 18px">Sub. Frequency: ${filtered[0]?.schedule.subscription_frequency}</li>
                        </ul>`;
        }
        
        setTopDetails((orderIDFromSub)?top_details:'');
        // filter based on Status
        // filtered = filtered?.filter(item =>
        //     status === "Enabled"
        //         ? item.enabled
        //         : status === "Disabled"
        //             ? !item.enabled
        //             : item
        // );

        // filtered = internalSearch(filterState, "cartID", filtered); 
        
        // Map table rows
        if(topDetails == ''){
            filtered = filtered?.map(obj => ({
                cartID: obj.cartID,
                subscriptionID: (<TextLink
                                    text={obj.id}
                                    onClick={() => {
                                        setClickedSubscription({id: obj?.id, userId: obj.cart_data?.user_id})
                                        handleOpenSubscriptionModal()
                                        // push(`/subscription/orders/${obj.id}`)
                                    }}
                                />),
                userID: (<TextLink
                            text={obj.cart_data?.user_id}
                            onClick={() => {
                                // push(`${location.pathname}/${obj?.userId}`)
                                setClickedCustomer({id: obj.cart_data?.user_id, mobile: obj?.cart_data?.get_user_details?.mobile, name: obj?.cart_data?.get_user_details?.first_name + " " + obj?.cart_data?.get_user_details?.last_name})
                                handleOpenModal()
                            }}
                        />),
                // spID: (spID
                //     <TextLink
                //         text={spID}
                //         onClick={() =>
                //             window.open(
                //                 `/service-providers-new/service-providers/${spID}/documents`,
                //                 "_blank"
                //             )
                //         }
                //     />
                // ),
                packageName: obj.get_cart_package_details[0]?.package_name,
                address: (
                    <TextLink
                        text={obj.service_address[0].line2}
                        onClick={() =>
                            window.open(
                                `https://www.google.com/maps/search/?api=1&query=${obj.service_address[0].latitude},${obj.service_address[0].longitude}`,
                                "_blank"
                            )
                        }
                    />
                ),
                city: obj.service_address[0].city,
                subcategory: obj.get_cart_package_details[0]?.get_sub_category_details?.name,
                serviceDate: obj.serviceDate,
                serviceTime: obj.serviceTime,
                startDate: obj.schedule.start_date,
                endDate: obj.schedule.end_date,
                subscriptionFrequency: obj.schedule.subscription_frequency,
                // weekdays: '',
                total: obj.get_transaction_details?.payable_amount?.toFixed(2),
                transactionID: (
                    <TextLink
                        text={obj.get_transaction_details?.transaction_id}
                        onClick={() =>
                            window.open(
                                `https://dashboard.razorpay.com/app/payments/${obj.get_transaction_details?.transaction_id}`,
                                "_blank"
                            )
                        }
                    />
                ),
                createdAt: `${new Date(obj.createdAt).toLocaleString()}`
            }));
        }else{
            filtered = filtered?.map(obj => ({
                cartID: obj.cartID,
                subscriptionID: (<TextLink
                                    text={obj.id}
                                    onClick={() => {
                                        setClickedSubscription({id: obj?.id, userId: obj.cart_data?.user_id})
                                        handleOpenSubscriptionModal()
                                        // push(`/subscription/orders/${obj.id}`)
                                    }}
                                />),
                userID: (<TextLink
                            text={obj.cart_data?.user_id}
                            onClick={() => {
                                // push(`${location.pathname}/${obj?.userId}`)
                                setClickedCustomer({id: obj.cart_data?.user_id, mobile: obj?.cart_data?.get_user_details?.mobile, name: obj?.cart_data?.get_user_details?.first_name + " " + obj?.cart_data?.get_user_details?.last_name})
                                handleOpenModal()
                            }}
                        />),
                // spID: (spID
                //     // <TextLink
                //     //     text={spID}
                //     //     onClick={() =>
                //     //         window.open(
                //     //             `/service-providers-new/service-providers/${spID}/documents`,
                //     //             "_blank"
                //     //         )
                //     //     }
                //     // />
                // ),
                // packageName: obj.get_cart_package_details[0]?.package_name,
                // address: (
                //     <TextLink
                //         text={obj.service_address[0].line2}
                //         onClick={() =>
                //             window.open(
                //                 `https://www.google.com/maps/search/?api=1&query=${obj.service_address[0].latitude},${obj.service_address[0].longitude}`,
                //                 "_blank"
                //             )
                //         }
                //     />
                // ),
                city: obj.service_address[0].city,
                subcategory: obj.get_cart_package_details[0]?.get_sub_category_details?.name,
                serviceDate: obj.serviceDate,
                serviceTime: obj.serviceTime,
                // startDate: obj.schedule.start_date,
                // endDate: obj.schedule.end_date,
                // subscriptionFrequency: obj.schedule.subscription_frequency,
                // weekdays: '',
                total: obj.get_transaction_details?.payable_amount?.toFixed(2),
                transactionID: (
                    <TextLink
                        text={obj.get_transaction_details?.transaction_id}
                        onClick={() =>
                            window.open(
                                `https://dashboard.razorpay.com/app/payments/${obj.get_transaction_details?.transaction_id}`,
                                "_blank"
                            )
                        }
                    />
                ),
                createdAt: `${new Date(obj.createdAt).toLocaleString()}`
            }));
        }

        // filtered = internalSearch(filterState, "city", filtered);

        setTableRows(filtered);
    }, [orderData, status, filterState,cPage,searchData]);

    const onSearch = () => {
        localStorage.removeItem('orderID');
        setSearchData(filterState);
        //setCPage(1);
    };

    // Table Header
    if(topDetails == ''){
        var headcol = [
            {
                title: "Order",
                sortBy: "cartID"
            },
            {
                title: "Subscription",
                sortBy: "subscriptionID"
            },
            {
                title: "Customer"
            },
            // {
            //     title: "Provider"
            // },
            {
                title: "Package"
            },
            {
                title: "Address",
                sortBy: "address"
            },
            {
                title: "City",
                sortBy: "city"
            },
            {
                title: "Sub Category",
                sortBy: "subcategory"
            },
            {
                title: "Service Date",
                sortBy: "startDate"
            },
            {
                title: "Service Time"
            },
            {
                title: "Start Date"
            },
            {
                title: "End Date"
            },
            {
                title: "Subscription"
            },
            // {
            //     title: "Weekdays"
            // },
            {
                title: "Total Amount"
            },
            {
                title: "Transaction"
            },
            {
                title: "Created",
                sortBy: "createdAt"
            }
        ];
    }else{
        var headcol = [
            {
                title: "Order",
                sortBy: "cartID"
            },
            {
                title: "Subscription",
                sortBy: "subscriptionID"
            },
            {
                title: "Customer"
            },
            // {
            //     title: "Provider"
            // },
            // {
            //     title: "Package"
            // },
            // {
            //     title: "Address",
            //     sortBy: "address"
            // },
            {
                title: "City",
                sortBy: "city"
            },
            {
                title: "Sub Category",
                sortBy: "subcategory"
            },
            {
                title: "Service Date",
                sortBy: "startDate"
            },
            {
                title: "Service Time"
            },
            // {
            //     title: "Start Date"
            // },
            // {
            //     title: "End Date"
            // },
            // {
            //     title: "Subscription"
            // },
            // {
            //     title: "Weekdays"
            // },
            {
                title: "Total Amount"
            },
            {
                title: "Transaction"
            },
            {
                title: "Created",
                sortBy: "createdAt"
            }
        ];
    }
    const tableHeaders = useMemo(
        () => headcol,
        [tableRows]
    );
    
    return (
        <div>
            <div dangerouslySetInnerHTML={{ __html: topDetails }}></div>
            <div className={styles.filter}>
                <TextInput
                    search
                    label="Order"
                    name="orderID"
                    onChange={e =>
                        setfilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />
                <TextInput
                    search
                    label="Subscription"
                    name="subscriptionID"
                    onChange={e =>
                        setfilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />
                {/* <p>Status</p>
                <select name="orderStatus" onChange={e => setfilterState({...filterState, [e.target.name]: e.target.value})} className={styles.input}>
                    <option value="All">All</option>
                    <option value="Scheduled">Scheduled</option>
                    <option value="ReScheduled">ReScheduled</option>
                    <option value="Routed">Routed</option>
                    <option value="ProviderAssigned">ProviderAssigned</option>
                    <option value="ProviderOnTheWay">ProviderOnTheWay</option>
                    <option value="ProviderArrived">ProviderArrived</option>
                    <option value="ProviderOTPSent">ProviderOTPSent</option>
                    <option value="ProviderOTPConfirmed">ProviderOTPConfirmed</option>
                    <option value="InProgress">InProgress</option>
                    <option value="Completed">Completed</option>
                </select> */}
                {/* <FilterDropdown
                    
                    label="Status"
                    name="orderStatus"
                    options={["All","Scheduled","ReScheduled","Routed","ProviderAssigned","ProviderOnTheWay","ProviderArrived","ProviderOTPSent","ProviderOTPConfirmed","InProgress","Completed","AdditionalCharges"]}
                /> */}
                &nbsp;
                <button className={'btn btn-primary'} style={{margin: '0 0 10px'}}
                        onClick={userRole?.find(item => item.privilege === "Read") ? onSearch : null}
                >Search
                </button>&nbsp;&nbsp;

                <button className={'btn btn-info'} style={{margin: '0 0 10px'}}
                        onClick={clearSearch}
                >Clear
                </button>&nbsp;&nbsp;
                
                {spLoader ? (
                    <div className={styles.loading__container}>
                    <Loader />
                    </div>
                ) : null}
            </div>
            <TableOrder 
                headers={tableHeaders} 
                data={tableRows} 
                spLoader={spLoader} 
                current={orderData?.maxPages}
                totalPage={Math.ceil(tableRows?.count / 10)}
            />

            {(tableRows && !spLoader)?<PageNavigator
                pageCount={lastPage}
                currentPage={cPage}
                onClick={e => {setCPage(e)}}
            />:''}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <ReportModal clickedCustomer={clickedCustomer} handleCloseModal={handleCloseModal}/>
            </Modal>

            <Modal
                open={openOrderModal}
                onClose={handleOpenOrderModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <OrderModal clickedOrder={clickedOrder} handleCloseModal={handleCloseOrderModal}/>
            </Modal>

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SubscriptionModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            {/*openOrderModal*/}
        </div>
    );
}
